import { render, staticRenderFns } from "./FormFloatingLabel.vue?vue&type=template&id=04b673e4"
import script from "./FormFloatingLabel.vue?vue&type=script&lang=js"
export * from "./FormFloatingLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports